const sortObjectsByString = (arr: any, string: string) => {
  arr.sort((a: any, b: any) => {
    const fa = a[string]?.toLowerCase(),
      fb = b[string]?.toLowerCase()

    if (fa < fb) {
      return -1
    }
    if (fa > fb) {
      return 1
    }
    return 0
  })

  return arr
}

export default sortObjectsByString
